import { useMemo } from 'react';
import { connectorGeometry, SIDE_ANCHORS } from '../../doc/connector';
import { useBoard, usePane } from '../context';
import { connectorOps, OpPaths } from '../items/ConnectorItem';
import { screenBox } from '../viewport/camera';
import { boardBoxes } from './connectors';

/**
 * The connector being drawn with the connector tool, before it is in the document. Lives in the
 * world layer, so it is drawn in world units like the real thing.
 */
export function ConnectorPreview() {
  const board = useBoard();
  const props = usePane((s) => s.connecting);
  const ops = useMemo(() => (props ? connectorOps(props, connectorGeometry(props, boardBoxes(board))) : null), [board, props]);
  if (!ops) return null;
  return (
    <svg className="connector-svg connector-preview" width={1} height={1} overflow="visible" aria-hidden>
      <OpPaths ops={ops} />
    </svg>
  );
}

/**
 * The item a connector end would attach to: outlined, with its four side dots; the dot the end
 * would take is filled, and the outline alone stays when the end would float.
 */
export function ConnectTargetOverlay() {
  const board = useBoard();
  const target = usePane((s) => s.connectTarget);
  const camera = usePane((s) => s.camera);
  const item = target ? board.index.get(target.itemId) : undefined;
  if (!target || !item) return null;
  return (
    <div
      className={`connect-target${target.anchor ? '' : ' is-floating'}`}
      style={{ ...screenBox(camera, item), transform: `rotate(${item.rotation + camera.rot}deg)` }}
    >
      {SIDE_ANCHORS.map((a) => (
        <div
          key={`${a.x},${a.y}`}
          className={`connect-dot${target.anchor?.x === a.x && target.anchor?.y === a.y ? ' is-active' : ''}`}
          style={{ left: `${a.x * 100}%`, top: `${a.y * 100}%` }}
        />
      ))}
    </div>
  );
}
